import { BrowserRouter, Route, Routes  } from 'react-router-dom';
import Login from "./pages/Login"
import CheckUser from "./pages/CheckUser"
import Home from "./pages/Home"
import AuthRoute from './components/AuthRoute';
import User from './pages/User';
import UpdateUserPassword from './pages/UpdateUserPassword';
import ResetPassword from './pages/ResetPassword';
import ForgetPassword from './pages/ForgotPassword';
import RequestAccount from './pages/RequestAccount';
import CaseManagement from './pages/CaseManagement';
import CaseCreation from './pages/CaseCreation';
import CaseCreationWizard from './pages/CaseCreationWizard';
import MasterDataManagement from './components/MasterDataManagement';
import ScoringMethod from './pages/ScoringMethod';
import References from './pages/References';

function Router() {
  return (
  <BrowserRouter>
      <Routes>
      
      <Route path="/Login"  element={<Login/>}/>
      <Route path="/check-user"  element={<CheckUser/>}/>
      <Route path="/create-password"  element={<UpdateUserPassword/>}/>
      <Route path="/forgotpassword" element={<ForgetPassword/>}/>
      <Route path="/resetpassword" element={<ResetPassword/>}/>
      <Route path="/signup" element={<RequestAccount/>}/>


      <Route path="/" element={<AuthRoute><Home/></AuthRoute>}/>
      <Route path="/users" element={<AuthRoute><User/></AuthRoute>}/>
      <Route path="/cases" element={<AuthRoute><CaseManagement/></AuthRoute>}/>
      <Route path="/create-case" element={<AuthRoute><CaseCreation/></AuthRoute>}/>
      <Route path="/create-case-wizard" element={<AuthRoute><CaseCreationWizard/></AuthRoute>}/>
      <Route path="/master-data" element={<AuthRoute><MasterDataManagement/></AuthRoute>}/>
      <Route path="/scoring-method" element={<AuthRoute><ScoringMethod/></AuthRoute>}/>
      <Route path="/references" element={<AuthRoute><References/></AuthRoute>}/>
    
   

      </Routes>
  </BrowserRouter>
  )
}
export default Router